var map = {
	"./bg/strings.json": 1806,
	"./cs/strings.json": 1807,
	"./da/strings.json": 1808,
	"./de/strings.json": 1809,
	"./el/strings.json": 1810,
	"./es-ES/strings.json": 1811,
	"./es-LA/strings.json": 1812,
	"./et/strings.json": 1813,
	"./fi/strings.json": 1814,
	"./fr-CA/strings.json": 1815,
	"./fr/strings.json": 1816,
	"./it/strings.json": 1817,
	"./lt/strings.json": 1818,
	"./lv/strings.json": 1819,
	"./nl/strings.json": 1820,
	"./no/strings.json": 1821,
	"./pl/strings.json": 1822,
	"./pseudo/strings.json": 1823,
	"./pt/strings.json": 1824,
	"./ro/strings.json": 1825,
	"./sk/strings.json": 1826,
	"./sl/strings.json": 1827,
	"./sv/strings.json": 1828,
	"./zh-CN/strings.json": 1829,
	"./zh-TW/strings.json": 1830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1805;